import React, { FunctionComponent, useCallback } from 'react';
import { FormControl } from 'react-bootstrap';
import { Field } from 'react-final-form';

type Props = {
  className?: string;
  property: string;
  defaultValue?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  format?: (value: any) => any;
  parse?: (value: any) => any;
  validate?: (v: number, allValues?: unknown) => string | undefined;
};

export const NumberFieldWithToggle: FunctionComponent<Props> = ({
  className,
  defaultValue,
  min,
  max,
  property,
  disabled,
  format,
  parse,
  validate,
}) => {
  // 永遠給 Field 一個 validator，內部自行判斷 disabled
  const fieldValidate = useCallback(
    (v: any, all?: unknown) => {
      if (disabled) return undefined;
      return validate ? validate(v, all) : undefined;
    },
    [disabled, validate]
  );

  // 安全 parse：空字串 => undefined；其餘轉 number
  const safeParse = useCallback(
    (v: any) => {
      if (v === '' || v === null || typeof v === 'undefined') return undefined;
      const n = Number(v);
      return Number.isNaN(n) ? undefined : n;
    },
    []
  );

  return (
    <Field
      key={`${property}-${disabled ? 'disabled' : 'enabled'}`} // 切換時強制 remount 清除舊 meta
      name={property}
      defaultValue={defaultValue}
      type="number"
      format={format}
      parse={parse ?? safeParse}
      validate={fieldValidate}
    >
      {({ input, meta }) => (
        <>
          <FormControl
            {...input}
            type="number"
            min={min}
            max={max}
            className={className}
            disabled={disabled}
          />
          {/* disabled 時不顯示錯誤，避免 UI 上殘留 */}
          {!disabled &&
            meta.error &&
            (meta.touched || meta.submitFailed) &&
            !meta.active && (
              <span className="text-danger">{meta.error}</span>
            )}
        </>
      )}
    </Field>
  );
};
